import React from 'react';
import Modal from './Modal';
import { cn } from '../../utils/cn';
import Icon from '../AppIcon';

const StyledModal = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'xl',
  variant = 'gold',
  showStats = false,
  stats = [],
  footer,
  icon,
  iconColor,
  className,
  ...props
}) => {
  const variantStyles = {
    gold: {
      gradient: 'from-white/5 to-white/2',
      border: 'border-white/12',
      iconColor: '#FFFFFF',
    },
    blue: {
      gradient: 'from-white/5 to-white/2',
      border: 'border-white/12',
      iconColor: '#FFFFFF',
    },
    green: {
      gradient: 'from-white/5 to-white/2',
      border: 'border-white/12',
      iconColor: '#FFFFFF',
    },
    amber: {
      gradient: 'from-white/5 to-white/2',
      border: 'border-white/12',
      iconColor: '#FFFFFF',
    },
    cyan: {
      gradient: 'from-white/5 to-white/2',
      border: 'border-white/12',
      iconColor: '#FFFFFF',
    },
    red: {
      gradient: 'from-white/5 to-white/2',
      border: 'border-white/12',
      iconColor: '#FFFFFF',
    },
  };

  const styles = variantStyles?.[variant] || variantStyles?.gold;
  const displayIconColor = iconColor || styles?.iconColor;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      icon={icon}
      iconColor={displayIconColor}
      footer={footer}
      {...props}
    >
      <div className={cn('space-y-4', className)} dir="rtl">
        {/* Summary Stats */}
        {showStats && stats?.length > 0 && (
          <div className={cn('grid gap-3 mb-4', `grid-cols-${Math.min(stats?.length, 4)}`)}>
            {stats?.map((stat, index) => (
              <div
                key={index}
                className={cn(
                  'bg-gradient-to-br rounded-lg p-3 border',
                  stat?.gradient || styles?.gradient,
                  stat?.border || styles?.border
                )}
              >
                <div className="flex items-center gap-2 mb-1">
                  {stat?.icon && (
                    <Icon
                      name={stat?.icon}
                      size={16}
                      color={stat?.iconColor || displayIconColor}
                    />
                  )}
                  <p className={cn('text-xs', stat?.labelColor || 'text-muted-foreground')}>
                    {stat?.label}
                  </p>
                </div>
                <p className={cn('text-xl font-bold', stat?.valueColor || 'text-foreground')}>
                  {stat?.value}
                </p>
              </div>
            ))}
          </div>
        )}

        {/* Content */}
        {children}
      </div>
    </Modal>
  );
};

export default StyledModal;